// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
require("font-awesome/css/font-awesome.min.css")
require("./plugins/pace/pace-theme-center-radar.min.css");
require("./plugins/pace/pace-theme-corner-indicator.min.css");
require("./plugins/pace/pace-theme-minimal.min.css");
/*require("./plugins/respond/respond.min.js");*/
require("./plugins/html5shiv/html5shiv.min.js");
require("es6-shim/es6-shim.min.js");
require("pace/pace.js");

require("./plugins/chartjs/Chart.min.js")
require("./bootstrap/css/bootstrap.css");
require("ionicons/dist/css/ionicons.min.css");

require("./plugins/jvectormap/jquery-jvectormap-1.2.2.css");
require("./css/skins/_all-skins.css");
require("./css/AdminLTE.css");
require("./less/list-group.less");
require("./plugins/jstree/themes/default/style.min.css")

require("./router.js")
require("./plugins/sparkline/jquery.sparkline.min.js")
// 适配flex
require("./plugins/flexible/flexible.js")
require("./bootstrap/js/bootstrap.min.js")
require("./plugins/jvectormap/jquery-jvectormap-1.2.2.min.js")
require("./plugins/jvectormap/jquery-jvectormap-world-mill-en.js")
require("./plugins/slimScroll/jquery.slimscroll.min.js")
require("./js/app.js")



$(document).ajaxStart(function() { Pace.restart(); });







// WEBPACK FOOTER //
// ./src/main.js